export function formatStatus(status) {
  const statusMap = {
    Consolidado: 'success',
    Pendente: 'warning',
    Cancelado: 'danger',
    Quitado: 'primary',
  }

  return statusMap[status] || 'secondary'
}
